<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
    </div>
    <div class="content_main">
      <div class="button_area margin_bottom">
        <input
          type="button"
          :value="backButton"
          class="finish_button"
          @click="toList"
        />
      </div>

      <div class="table_area margin_bottom">
        <table rules="rows">
          <tr class="items_table">
            <th class="table_header">
              <label>{{ typeLabel }}</label>
            </th>
            <td class="table_contents">
              <label v-if="mail.type == 0">{{ allLabel }}</label>
              <label v-if="mail.type == 1">{{ individualLabel }}</label>
              <label v-if="mail.type == 2">{{ thresholdLabel }}</label>
              <label v-if="mail.type == 3">{{ reserveLabel }}</label>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ titleLabel }}</label>
            </th>
            <td class="table_contents">
              <div class="message_area">{{ mail.title }}</div>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ messageLabel }}</label>
            </th>
            <td class="table_contents">
              <div class="message_area">{{ mail.message }}</div>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ userMailLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ mail.mailAddress }}</label>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ startDateLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ sendDateTime }}</label>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ endDateLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ completeDateTime }}</label>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ sendResultLabel }}</label>
            </th>
            <td class="table_contents">
              <div>
                <div>
                  <label>{{ totalLabel }}</label>
                  <label>{{ mail.total }}</label>
                </div>
                <div>
                  <label>{{ successLabel }}</label>
                  <label>{{ mail.success }}</label>
                </div>
                <div>
                  <label>{{ failureLabel }}</label>
                  <label>{{ mail.failure }}</label>
                </div>
              </div>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ userIdLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ mail.userId }}</label>
            </td>
          </tr>
        </table>
      </div>

      <!-- 送信したテナント一覧 -->
      <div class="table_title_area">
        <div>{{ tenantListLabel }}</div>
        <div class="flex">
          <label>{{ sendResultLabel }}:</label>
          <input
            id="all"
            type="radio"
            value="-1"
            v-model="result"
            @change="setMailResults()"
          />
          <label for="all">{{ all }}</label>
          <input
            id="success"
            type="radio"
            value="0"
            v-model="result"
            @change="setMailResults(1)"
          />
          <label for="success">{{ success }}</label>
          <input
            id="failure"
            type="radio"
            value="1"
            v-model="result"
            @change="setMailResults(0)"
          />
          <label for="failure">{{ failure }}</label>
        </div>
      </div>

      <div class="tenant_list table_area">
        <table class="content_title" rules="rows">
          <tr class="items_table">
            <td class="table_contents">
              <label>{{ companyNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantIdLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ mailAddressLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ resultLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ reasonLabel }}</label>
            </td>
          </tr>
        </table>

        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="(company, index) in resultList"
            :key="index"
          >
            <td class="table_contents">
              <label>{{ company.corporationName }}</label>
            </td>
            <td class="table_contents">
              <label>{{ company.companyId }}</label>
            </td>
            <td class="table_contents">
              <label>{{ company.companyName }}</label>
            </td>
            <td class="table_contents">
              <label>{{ company.mailAddress }}</label>
            </td>
            <td class="table_contents">
              <label v-if="company.result == 0">{{ failure }}</label>
              <label v-if="company.result == 1">{{ success }}</label>
            </td>
            <td class="table_contents">
              <label>{{ company.reason }}</label>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom margin_bottom">
        <pagination
          v-model="page"
          :records="total"
          :per-page="pageSize"
          :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
          @paginate="setCorporations(page - 1)"
        >
        </pagination>
      </div>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import datepicker from 'vue-flatpickr-component'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import confirmCustomTitleModalWindow from '../modalWindow/confirmCustomTitleModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'メール詳細',
      typeLabel: '送信契機',
      allLabel: '一斉',
      individualLabel: '個別',
      thresholdLabel: '閾値超過',
      reserveLabel: '更新予約処理結果',
      titleLabel: 'タイトル',
      messageLabel: '本文',
      startDateLabel: '送信日時',
      endDateLabel: '送信完了日時',
      userIdLabel: '送信管理者ID',
      userMailLabel: '送信元メールアドレス',
      sendResultLabel: '送信結果',
      totalLabel: '総数：',
      successLabel: '成功：',
      failureLabel: '失敗：',
      tenantListLabel: '送信したメールアドレス一覧',
      tenantIdLabel: 'テナントID',
      tenantNameLabel: 'テナント名',
      companyNameLabel: '法人名',
      mailAddressLabel: 'メールアドレス',
      resultLabel: '結果',
      reasonLabel: '理由',
      all: 'すべて',
      success: '成功',
      failure: '失敗',
      backButton: '戻る',
      result: -1, // -1:すべて 0:成功 1:失敗
      showloadingModal: false,
      showFailureModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      resultPartList: []
    }
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.mailHistory.mail.companyList.length
      ) {
        return this.$store.state.mailHistory.mail.companyList.length
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >=
        this.$store.state.mailHistory.mail.companyList.length
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.mailHistory.mail.companyList.length / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    resultList() {
      return this.$store.state.mailHistory.mail.companyList.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      )
    },
    mail() {
      return this.$store.state.mailHistory.mail
    },
    sendDateTime() {
      var s = new Date(this.$store.state.mailHistory.mail.sendDateTime)
      if (s) {
        var sendDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        return sendDateTime
      }
      return ''
    },
    completeDateTime() {
      var s = new Date(this.$store.state.mailHistory.mail.completeDateTime)
      if (s) {
        var completeDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        return completeDateTime
      }
      return ''
    }
  },
  components: {
    datepicker,
    completeModalWindow,
    confirmCustomTitleModalWindow,
    loadingModalWindow,
    Pagination
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    async toList() {
      this.$router.push('/master/mailHistory')
    },
    close() {
      this.showFailureModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (this.sysErrorMsg[errorMessage]) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else if (error.response && error.response.data) {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0117.name +
          this.sysErrorMsg.MSGCRD0117.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    },
    async setMailResults(resultType) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        await this.$store.dispatch('mailHistory/setMailHistoriesDetail', {
          mailHistoryId: this.$store.state.mailHistory.selectMailHistoryId,
          result: resultType
        })
        this.setCorporations(0)
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_690001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0117')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    setCorporations(pageNo) {
      this.page = pageNo + 1
    }
  }
}
</script>
<style scoped>
.button_area {
  display: flex;
  justify-content: end;
}
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.content_title {
  background-color: #ddffff;
  width: 100%;
}
.content_main {
  height: calc(100% - 110px);
  position: relative;
  background-color: #fff;
  padding: 26px 32px;
  overflow-y: scroll;
}
.table_area {
  border: 1px solid #a6e3e0;
}
table {
  width: 100%;
  table-layout: fixed;
  border-color: #a6e3e0;
}
.table_header {
  background-color: #ddffff;
  width: 20%;
}
.tenant_list .table_contents {
  width: 30%;
}
.table_contents {
  width: 80%;
}
.bottom {
  height: 53px;
  width: 100%;
  border-top: none;
  background-color: #ddffff;
  position: sticky;
  bottom: auto;
}
.message_area {
  max-width: 500px;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.table_title_area {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/mailHistory/mailHistoryDetail.vue